module.exports = __webpack_public_path__ + "img/antenna-06.844fdc32.svg";